export default __webpack_public_path__ + "static/media/avatar_bg_hyunga.83ff7ab7.png";